export default "__VITE_ASSET__03b97497__"